import {footerNavigation} from "../utilities/navigation.js";

export const footer = (totalResults, resultsPerPage, pageNumber) => {
  const searchTableDivParent = document.getElementById("searchTableDiv")
  const tableFooterDiv = document.createElement("div")
  tableFooterDiv.setAttribute("class", "row container")
  tableFooterDiv.setAttribute("id", "tableFooter")

  let page = pageNumber
  let pageDisplaySize = resultsPerPage

  const range = [];
  const num = Math.ceil(totalResults / pageDisplaySize);
  tableFooterDiv.innerHTML = ""
  for (let i = 1; i <= num; i++) {
    range.push(i);
  }

  console.log('num pages: ' + range.length)
  tableFooterDiv.innerHTML = `
      <div class="col-sm-10 col-md-4" id="pageNumbersInfo">
      </div>
      `
  if (range.length > 1){
    tableFooterDiv.innerHTML += `
          <nav class="col-sm-12 col-md-8" id="paginationNumbers">
            <div class="dataTables_paginate">
                <ul class="pagination">
                    <li ${page === 1 ? "class='paginate_button page-item previous hidden'"
      : "class='paginate_button page-item previous'"}>
                        <a class="page-link" onclick=setPageNumber(${page - 1}) tabindex="${0}">Previous</a>
                    </li>
                    ${range.map((el) =>(
      `<li ${page === el ? "class='page-item active'" : "class='page-item'"}>
                            <a class="page-link" onclick=setPageNumber(${el}) tabindex="${0}">${el}</a>
                         </li>`
    )).join('')}
                    <li ${page === range.length ? "class='paginate_button page-item previous hidden'"
      : "class='paginate_button page-item previous'"}>
                        <a class="page-link" onclick=setPageNumber(${page + 1}) tabindex="${0}">Next</a>
                    </li>
                </ul>
            </div>
        </nav>
  `

  }

  if(page === 0){
    tableFooterDiv.children['pageNumbersInfo'].innerHTML =  `
      ${page === 0 ? (page +1) + "-" + pageDisplaySize + " of " + totalResults :  (page * 10) - 9 + "-" + page * 10 + " of " + totalResults}
      `
  }else if(page === 1){
    if(totalResults < 10){
      tableFooterDiv.children['pageNumbersInfo'].innerHTML =  `
      ${page + "-" + totalResults + " of " + totalResults}
      `
    }else{
      tableFooterDiv.children['pageNumbersInfo'].innerHTML =  `
      ${page === 1 || page === 0 ? page + "-" + pageDisplaySize + " of " + totalResults :  (page * 10) - 9 + "-" + page * 10 + " of " + totalResults}
      `
    }
  }else{
    tableFooterDiv.children['pageNumbersInfo'].innerHTML =  `
      ${(page * pageDisplaySize) - 9 + "-" + page * pageDisplaySize + " of " + totalResults}
      `
  }

  searchTableDivParent.appendChild(tableFooterDiv)
  const pageNumberFocus = document.querySelectorAll('.page-link')
  footerNavigation(pageNumberFocus, page)
}

